export const log = {
  download: id => {
    console.log("log download", id);
    if (window.cf_log_document_download) {
      window.cf_log_document_download(id);
    } else {
      console.error("Missing function: window.cf_log_document_download");
    }
  },
  videoView: id => {
    console.log("log videoView", id);
    if (window.cf_log_video_view) {
      window.cf_log_video_view(id);
    } else {
      console.error("Missing function: window.cf_log_video_view");
    }
  }
};
